const commonAndMisc = {
  errorMessage404: "哎呀！您正在查看的页面不存在", // translated
  errorContentUnavailable: "哎呀！您要查找的内容不存在。请联系我们了解问题", // translated
  backToHome: "返回首页", // translated
  information: "信息", // translated
  additionalInformation: "附加信息", // translated
  destinationPlaceholder: "你要去哪里", // translated
  aboutUs: "关于我们", // translated
  pleaseWait: "请稍等...", // translated
  featuredHotels: "特色酒店", // translated
  topPackages: "热门套餐", // translated
  topTours: "热门旅游", // translated
  traveller: "游客", // translated
  reviews: "评论", // translated
  home: "主页", // translated
  packages: "套餐", // translated
  experiences: "经验", // translated
  close: "关闭", // translated
  loadingMessage: "我们正在搜索最优惠的价格，请稍候", // translated
  loadingMessageTheHotelCo: "我们正在搜索最优惠的价格，请稍候", // translated
  loadingMessageSearchStrip: "我们正在搜索最优惠的价格，请稍候...", // translated

  stillSearchingHotels:
    "Still searching — {{priced}} of {{discovered}} hotels priced",
  hotelsProgressCount: "Found {{priced}} of {{discovered}} hotels",
  searchingSuppliers: "Checking {{suppliers}}",
  topCountriesToVisit: "最值得参观的国家", // translated
  profile: "账户", // translated
  reservations: "预订", // translated
  address: "地址", // translated
  firstName: "名", // translated
  lastName: "姓", // translated
  email: "电子邮件", // translated
  login: "登录", // translated
  logout: "登出", // translated
  myProfile: "我的账户", // translated
  myQuotations: "我的报价", // translated
  myChatRooms: "我的聊天", // translated
  chatRoomsListEmpty: "此账户暂无聊天室。", // translated
  chatRoomsOpen: "开放", // translated // translated 
  chatRoomsLastActivity: "最近活动", // translated
  chatRoomsUnread: "未读", // translated
  chatRoomsBadgeQuotation: "报价", // translated // translated 
  chatRoomsBadgeTripOffer: "行程报价", // translated
  chatRoomsOpenQuotationAria: "打开报价聊天：{{name}}", // translated
  chatRoomsOpenTripOfferAria: "打开行程报价聊天：{{name}}", // translated
  chatRoomsOpenGenericAria: "打开聊天：{{name}}", // translated
  quotationChatInvalidLink:
    "聊天链接无效。请从个人资料或报价列表打开聊天，或仅使用 room_code 或 room_uid 之一。", // translated 
  quotationChatNoTripDetails: "此聊天无可用的行程详情。", // translated 
  chat: "聊天", // translated // translated 
  verified: "已验证", // translated
  unverified: "未验证", // translated
  selectLanguage: "选择语言", // translated
  selectCurrency: "选择货币", // translated
  upgrade: "升级", // translated
  membership: "会员资格", // translated
  travelTrust: "旅游信托", // translated
  signInUp: "登录/注册", // translated
  worldwideHotelsAndResortsAtAmazingWholesaleRates:
    "以惊人的批发价格提供全球酒店和度假村", // translated
  dashboard: "仪表板", // translated
  pricing: "价钱", // translated
  refundable: "可退款", // translated
  cars: "汽车", // translated
  cruises: "游轮", // translated
  view: "看法", // translated
  price: "价格", // translated
  totalPrice: "总价", // translated
  filterRoomName: "过滤室名称", // translated
  get: "得到", // translated
  guestInformationValidation: "客人信息验证", // translated
  reservation: "预订", // translated
  checkIn: "报到", // translated
  checkOut: "查看", // translated
  paymentInitiattionErroeMessage:
    "我们无法启动您的付款流程。对此造成的不便，我们表示歉意", // translated
  warning: "警告", // translated
  couldNotFindPriceForDateWarning: "我们无法找到该日期的价格。请换个日期重试", // translated
  searchFormValidationError: "搜索表单验证错误", // translated
  pleaseSelectValidDateFirst: "请先选择有效日期", // translated
  searchError: "搜索错误", // translated
  priceSearchInitiationError:
    "我们无法启动价格搜索流程。请稍后再试。对此造成的不便，我们表示歉意", // translated
  searchWarning: "搜索警告", // translated
  couldNotFindPriceAndOrAvailability:
    "我们无法找到符合您要求的价格和/或供货情况。对此造成的不便，我们表示歉意", // translated
  joinNow: "立即加入", // translated
  signIn: "登入", // translated
  searchNow: "现在搜索", // translated
  bookingFailed: "预订失败", // translated
  sorryForTheInconvenience: "对此造成的不便，我们表示歉意", // translated
  paymentFailedTryAgain: "支付失败。请再试一次", // translated
  quickLinks: "快速链接", // translated
  tours: "旅游", // translated
  termsAndConditions: "条款和条件", // translated
  pleaseWaitWhileInitiatingPayment: "我们正在启动您的付款流程，请稍候", // translated
  back: "返回", // translated
  nextStep: "下一步", // translated
  book: "书", // translated
  checkout: "查看", // translated
  specifyPickUpPoint: "指定您首选的接送点", // translated
  pickupPoint: "接送点", // translated
  optional: "选修的", // translated
  remarks: "评论", // translated
  travellerInformation: "旅客信息", // translated
  bookingRemarks: "预订备注", // translated
  bookingOverview: "预订概览", // translated
  paymentFailed: "支付失败", // translated
  paymentSuccess: "支付成功", // translated
  at: "在", // translated // translated 
  person: "人", // translated // translated 
  cancellationPolicy: "取消政策", // translated
  From: "从", // translated // translated 
  to: "到", // translated
  cancellationIs: "取消是", // translated
  pickup: "捡起", // translated
  flights: "航班", // translated
  Accommodation: "住宿", // translated
  payAndBook: "付款及预订", // translated
  onRequest: "根据要求", // translated
  weAreFindingTheBestAvailableServices: "我们正在寻找最好的可用服务", // translated
  withTheBestAvailablePrices: "以最优惠的价格", // translated
  inRealTime: "实时", // translated
  seconds: "秒", // translated // translated 
  thisProcessCanTakeUpToOneMinute: "此过程最多可能需要 1 分钟", // translated
  pleaseDoNotRefreshThisPage: "请不要刷新此页面", // translated
  wellItSeemsItCanTakeBitLonger: "呃……看来还需要更长的时间", // translated
  yourBrowserDoesNotSupportTheVideoTag: "您的浏览器不支持video标签", // translated
  bookingSuccess: "预订成功", // translated
  bookingReference: "预订参考", // translated
  referenceCopied: "已复制参考文献", // translated
  shortlyYouReceiveEmailContainingInformationForYourReservation:
    "很快，您将收到一封电子邮件，其中包含预订所需的所有信息", // translated
  viewMore: "查看更多", // translated
  readMore: "阅读更多", // translated
  customerSupport: "客户支持", // translated
  socialMedia: "社交媒体", // translated
  hours: "小时", // translated // translated 
  hour: "小时", // translated // translated 
  minutes: "分钟", // translated // translated 
  minute: "分钟", // translated // translated 
  memberId: "会员ID", // translated
  star: "星星", // translated
  stars: "星星", // translated
  proceed: "继续", // translated
  clearAllFilters: "清除所有过滤器", // translated
  clearYourFilters: "请清除您的筛选选项以查看结果", // translated
  noOptionsForSelectedFilters: "没有可用于匹配您的过滤器的选项", // translated
  privacyPolicy: "隐私政策", // translated
  security: "安全", // translated
  nearby: "附近", // translated
  distanceFromSelection: "距选择的距离", // translated
  km: "公里", // translated
  restaurants: "餐厅", // translated
  active: "积极的", // translated
  visitSite: "访问网站", // translated
  score: "分数", // translated
  applicationAvailable: "可申请", // translated
  sendUsEmail: "给我们发电子邮件", // translated
  sendUsYourRequest: "将您的请求发送给我们", // translated
  notAvailable: "无法使用", // translated
  found: "找到", // translated
  progressAt: "进展于", // translated
  currency: "货币", // translated
  sendUsRequest: "将您的请求发送给我们", // translated
  noReservationsForThisProduct: "该产品暂无预订", // translated
  confirmed: "确认的", // translated
  cancelled: "取消", // translated
  pending: "待办的", // translated
  status: "地位", // translated
  reference: "参考", // translated
  leadGuest: "首席嘉宾", // translated
  sendVoucherEmail: "发送优惠券电子邮件", // translated
  sendCancellationEmail: "发送取消电子邮件", // translated
  downloadVoucher: "下载优惠券", // translated
  emailHasBeenSent: "电子邮件已成功发送", // translated
  emailNotSentTryAgain: "电子邮件未发送！请再试一次", // translated
  titleIsRequired: "标题为必填项", // translated
  genderIsRequired: "性别为必填项", // translated
  firstNameMustContainAlphabetic: "名字只能包含字母字符", // translated
  firstNameIsRequired: "名字为必填项", // translated
  lastNameIsRequired: "姓氏为必填项", // translated
  lastNameMustContainAlphabetic: "姓氏只能包含字母字符", // translated
  phoneNumberInTheFormat: "电话号码格式必须不含空格", // translated
  phoneNumberIsRequired: "电话号码为必填项", // translated
  emailIsRequired: "电子邮件为必填项", // translated
  invalidEmail: "不合规电邮", // translated
  addressIsRequired: "地址为必填项", // translated
  cityIsRequired: "城市为必填项", // translated
  postalCodeIsRequired: "邮政编码为必填项", // translated
  countryIsRequired: "国家/地区为必填项", // translated
  yourReservationIsInProgress: "您的预订正在进行中", // translated
  clickHere: "点击这里", // translated
  iHaveReadAgreeWithAbove: "我已阅读并同意以上内容", // translated
  pleaseCheckTheBox:
    "请选中该框以表明您已阅读并同意所提供的信息，然后再继续下一步。", // translated
  myPoints: "我的积分", // translated
  myBookings: "我的预订", // translated
  myAccount: "我的账户", // translated
  provideImportantInfoForYourTravel: "让我们知道您旅行期间的任何重要信息", // translated
  noBookingsForThisProduct: "该产品暂无预订", // translated
  noReservationsOfThisProduct: "此产品类型暂无预订", // translated
  actions: "操作", // translated
  save: "保存", // translated
  on: "于", // translated
  gender: "性别", // translated
  nationality: "国籍", // translated
  amountIn: "入账金额", // translated
  amountOut: "出账金额", // translated
  yourReservationHasBeenRegistered: "您的预订已登记", // translated
  pleaseAcceptProperty:
    "请勾选顶部复选框，确认您预订的是所需的物业。", // translated
  ourContactNumbersAre: "我们的联系电话是", // translated
  contactUsToAssistWithYourBooking:
    "请联系我们以协助您预订。对此造成的不便，我们表示歉意", // translated
  sunday: "星期日", // translated
  operationalHours: "营业时间", // translated
  tuesday: "周二", // translated
  thursday: "周四", // translated
  wednesday: "周三", // translated
  saturday: "周六", // translated
  friday: "星期五", // translated
  monday_to_friday: "星期一到星期五", // translated
  monday: "周一", // translated
  closed: "关闭", // translated
  notConfirmed: "无效", // translated // translated 
  topUpPoints: "充值积分", // translated
  maintenanceTitle: "网站维护中", // translated 
  maintenanceDescription: "我们发放计划维护，请稍后再访问。", // translated 
  maintenanceCountdownLabel: "预计剩余时间", // translated 
  maintenanceLogoAlt: "网站标志", // translated 
  maintenanceDays: "天", // translated 
  maintenanceHours: "小时", // translated 
  maintenanceMinutes: "分钟", // translated 
  maintenanceSeconds: "秒", // translated 
  maintenanceStatusBadge: "计划维护", // translated 
  maintenanceRefresh: "刷新页面", // translated 
  maintenanceExpired: "维护工作很快完成，请刷新页面。", // translated 
};


export default commonAndMisc;
